<script lang="ts">
  import { onMount } from "svelte";
  import SearchDropdown from "../../components/Form/Fields/Dropdown/SearchDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { clfValueFields } from "../../utils/TableFields/clf-value.fields";
  import {
    canEdit,
    editing,
    init,
    loading,
    loadSchemaValues,
    onCreate,
    onDelete,
    onEdit,
    record,
    records,
    save,
    schemaItems,
    schemas,
    selectedSchema,
  } from "./settings-clf.store";

  let canSubmit = true;

  $: isNew = $record != null && $record.oid === 0;

  function onSchemaSelected(item: IDropdownItem) {
    let schema = $schemas.find((x) => x.oid == item.oid);
    if (!!schema) {
      selectedSchema.set(schema.oid);
      canEdit.set(schema.editable == 1);
      loadSchemaValues(schema.code);
    } else {
      records.set([]);
      selectedSchema.set(0);
      canEdit.set(true);
    }
  }

  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }

  onMount(init);
</script>

{#if $editing === false}
  <nav class="level">
    <div class="level-left">
      <div class="level-item">
        <p class="subtitle is-5">seleziona tabella</p>
      </div>

      <div class="level-item">
        <div class="field">
          <SearchDropdown
            name=""
            filterVisible={false}
            placeholder="tabella"
            items={$schemaItems}
            on:select={(x) => onSchemaSelected(x.detail)}
            value={$selectedSchema}
          />
        </div>
      </div>
    </div>
  </nav>

  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={clfValueFields}
      records={$records}
      pagination={null}
      createEnabled={$canEdit}
      editEnabled={$canEdit}
      deleteEnabled={$canEdit}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
      on:delete={(e) => onDelete(e.detail)}
    />
  </div>

  {#if !$canEdit}
    <div class="has-text-danger">
      Nota: la tabella selezionata non è modificabile.
    </div>
  {/if}
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="codice interno (10 caratteri)">
      <Input
        name="Codice"
        placeholder="codice"
        bind:value={$record.code}
        required={true}
        maxlength={10}
      />
    </FormField>

    <FormField
      usageHelp="ordine di visualizzazione (numerico). I valori vengono ordinati prima per ordine di visualizzazione e poi, a parità di ordine, per descrizione"
    >
      <NumberInput
        name="Ordine di Visualizzazione"
        placeholder="ordine visualizzazione"
        required={true}
        bind:value={$record.displayOrder}
      />
    </FormField>

    <FormField usageHelp="descrizione visibile (200 caratteri)">
      <Input
        name="Descrizione"
        placeholder="descrizione"
        required={true}
        maxlength={200}
        bind:value={$record.description}
      />
    </FormField>
  </FormLayout>
{/if}
